import * as yup from 'yup'

// login validation
export const aboutAppSchema = yup.object().shape({
    about: yup
        .string()
        .required('من فضلك ادخل معلومات حول التطبيق')
        .max(250, 'هذا الوصف طويل جدا '),
})
